import React from "react";
import "../../../assets/styles/edit-carousel.scss";
import { IconX } from "../../../icons/Icon";

const CarouselItem = ({ imageUrl, handleDelete }) => {
  return (
    <div className="wrapper-img">
      <div className="control-delete">
        <button
          type="button"
          className="btn delete-banner shadow"
          onClick={() => handleDelete()}
        >
          <IconX color="#fff" />
        </button>
      </div>
      <img src={imageUrl} alt="CAROUSEL" />
    </div>
  );
};

export default CarouselItem;
